export default function CategoryOptions({ category, values, onChange }) {
    return (
      <div>
        <h3 className="text-xl font-semibold mb-4 mt-4">
          {category.name}-Specific Options
        </h3>
  
        <div className="space-y-6">
          {category.specificOptions.map(opt => (
            <div key={opt.label}>
              <label className="block font-medium mb-2">{opt.label}</label>
  
              {opt.type === 'select' && (
                <select
                  className="w-full px-4 py-3 rounded-lg bg-gray-200 dark:bg-gray-800"
                  value={values[opt.label] || ''}
                  onChange={e =>
                    onChange(prev => ({ ...prev, [opt.label]: e.target.value }))
                  }
                >
                  <option value="">-- Choose --</option>
                  {opt.options.map(o => (
                    <option key={o} value={o}>{o}</option>
                  ))}
                </select>
              )}
  
              {opt.type === 'text' && (
                <input
                  type="text"
                  className="w-full px-4 py-3 rounded-lg bg-gray-200 dark:bg-gray-800"
                  value={values[opt.label] || ''}
                  onChange={e =>
                    onChange(prev => ({ ...prev, [opt.label]: e.target.value }))
                  }
                />
              )}
  
              {opt.type === 'color' && (
                <input
                  type="color"
                  className="w-full h-12 rounded-lg"
                  value={values[opt.label] || '#000000'}
                  onChange={e =>
                    onChange(prev => ({ ...prev, [opt.label]: e.target.value }))
                  }
                />
              )}
  
              {opt.type === 'emoji' && (
                <div className="grid grid-cols-5 gap-3">
                  {opt.emojis.map(emo => (
                    <button
                      key={emo}
                      className={`text-3xl p-3 rounded-lg transition ${
                        values[opt.label] === emo
                          ? 'ring-4 ring-indigo-500'
                          : 'bg-gray-200 dark:bg-gray-800'
                      }`}
                      onClick={() =>
                        onChange(prev => ({ ...prev, [opt.label]: emo }))
                      }
                    >
                      {emo}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
  